/*! nukumo — まとめ買い特典（0円の特典商品）・無料プレゼント・購入通知・レビュー・クーポン */
(function () {
  'use strict';
  if (window.__nkExtras) return;
  window.__nkExtras = true;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (c) { return (window.GB && GB.formatMoney) ? GB.formatMoney(c) : '¥' + Math.round(c / 100).toLocaleString('ja-JP'); };
  var root = function () { var GB = window.GB || {}; return ((GB.routes && GB.routes.root) || '/').replace(/\/$/, ''); };
  var readJSON = function (sel) { var el = document.querySelector(sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  var GIFT_PROPS = { _nk_gift: '1', '特典': '無料プレゼント' };
  var BUNDLE_PROPS = { _nk_bundle: '1', '特典': 'まとめ買い特典' };
  var onCartPage = function () { return document.body && document.body.classList.contains('template-cart'); };

  /* ---------- まとめ買い特典 ---------- */
  var BUNDLE, GRP;
  function bundleData() { if (BUNDLE === undefined) BUNDLE = readJSON('[data-nk-bundle-json]'); return BUNDLE; }
  function grp() {
    if (GRP) return GRP;
    GRP = {};
    var ch = (bundleData() || {}).choices || {};
    Object.keys(ch).forEach(function (pid) { ch[pid].forEach(function (v) { GRP[Number(v.id)] = pid; }); });
    return GRP;
  }
  function tierFor(B, q) {
    var want = null;
    (B.tiers || []).forEach(function (t) { if (want === null && q >= t.min) want = t.variants.map(Number); });
    return want;
  }
  function bonusIds(B) {
    var ids = Object.keys(grp()).map(Number);
    (B.tiers || []).forEach(function (t) { t.variants.forEach(function (v) { v = Number(v); if (ids.indexOf(v) < 0) ids.push(v); }); });
    return ids;
  }
  var post = function (path, body) {
    return fetch(root() + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  };
  function after() {
    if (onCartPage()) { window.location.reload(); return null; }
    var C = window.GB && GB.cart;
    return C && C.refresh ? C.refresh() : null;
  }
  function fail(d) {
    var msg = (d && (d.description || d.message)) || 'エラーが発生しました。時間をおいて再度お試しください。';
    var C = window.GB && GB.cart;
    if (C && C.error) C.error(msg); else if (window.GB && GB.toast) GB.toast(msg);
  }
  /* 本体の台数に合わせて特典を正しい内容にする（選んだ色は残す）。変更したら true */
  var bundleBusy = false;
  function syncBundle(c) {
    var B = bundleData();
    if (!B || !c) return false;
    if (bundleBusy) return true;
    var ids = bonusIds(B), G = grp(), q = 0, pool = [], missing = [];
    (c.items || []).forEach(function (it) {
      if ((it.properties && it.properties._nk_bundle) || ids.indexOf(Number(it.variant_id)) > -1) pool.push(it);
      else if (Number(it.product_id) === Number(B.product)) q += it.quantity;
    });
    (q ? tierFor(B, q) || [] : []).forEach(function (v) {
      var i = -1;
      pool.forEach(function (l, k) {
        if (i > -1 || l.quantity !== 1 || !(l.properties && l.properties._nk_bundle)) return;
        var lv = Number(l.variant_id);
        if (lv === v || (G[v] && G[v] === G[lv])) i = k;
      });
      if (i > -1) pool.splice(i, 1); else missing.push(v);
    });
    if (!pool.length && !missing.length) return false;
    bundleBusy = true;
    var chain = Promise.resolve();
    pool.forEach(function (l) { chain = chain.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); }); });
    if (missing.length) chain = chain.then(function () { return post('/cart/add.js', { items: missing.map(function (v) { return { id: v, quantity: 1, properties: BUNDLE_PROPS }; }) }); });
    chain.then(function () { bundleBusy = false; return after(); }).catch(function (d) { bundleBusy = false; fail(d); });
    return true;
  }
  function swapSelect(it) {
    var ch = ((bundleData() || {}).choices || {})[String(it.product_id)];
    if (!ch) return '';
    return '<label class="gb-line__swap"><span>色を選ぶ</span><select data-nk-bundle-swap data-key="' + esc(it.key) + '">' + ch.map(function (v) {
      return '<option value="' + v.id + '"' + (Number(v.id) === Number(it.variant_id) ? ' selected' : '') + '>' + esc(v.label) + '</option>';
    }).join('') + '</select></label>';
  }
  /* ドロワー：特典の行は数量変更・削除をできないようにする（色は選べる）。プレゼントは数量だけ固定 */
  function lockLines(c) {
    var drawer = document.querySelector('[data-gb-drawer]');
    if (!drawer || !c) return;
    (c.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (!p._nk_bundle && !p._nk_gift) return;
      var row = drawer.querySelector('[data-gb-line][data-key="' + String(it.key).replace(/"/g, '') + '"]');
      var act = row && row.querySelector('.gb-line__actions');
      if (!act) return;
      if (p._nk_bundle) act.innerHTML = swapSelect(it) + '<p class="gb-line__lock">本体の台数に合わせて自動で付きます（単体では削除できません）</p>';
      else { var qty = act.querySelector('.gb-qty'); if (qty) qty.parentNode.removeChild(qty); }
    });
  }
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-nk-bundle-swap]');
    if (!s) return;
    s.disabled = true; bundleBusy = true;
    post('/cart/change.js', { id: s.getAttribute('data-key'), quantity: 0 })
      .then(function () { return post('/cart/add.js', { items: [{ id: parseInt(s.value, 10), quantity: 1, properties: BUNDLE_PROPS }] }); })
      .then(function () { bundleBusy = false; return after(); })
      .catch(function (d) { bundleBusy = false; fail(d); s.disabled = false; });
  });

  /* ---------- 無料プレゼント ---------- */
  var GIFT, giftBusy = false;
  function giftData() { if (GIFT === undefined) GIFT = readJSON('[data-nk-gift-json]'); return GIFT; }
  function giftCalc(c) {
    var gl = null, base = 0;
    (c.items || []).forEach(function (it) {
      if (it.properties && it.properties._nk_gift) { if (!gl) gl = it; }
      else base += it.final_line_price || 0;
    });
    return { gl: gl, base: base };
  }
  function giftOptions(d, selected) {
    return (d.products || []).map(function (p) {
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      if (!vs.length) return '';
      return '<optgroup label="' + esc(p.title) + '">' + vs.map(function (v) {
        return '<option value="' + v.id + '"' + (String(v.id) === String(selected) ? ' selected' : '') + '>' + esc(p.title) + '（' + esc(v.label || '') + '）</option>';
      }).join('') + '</optgroup>';
    }).join('');
  }
  function giftBar(pct) { return '<span class="nk-gift__bar" aria-hidden="true"><i style="width:' + Math.max(3, Math.min(100, pct)) + '%"></i></span>'; }
  function renderGift(c) {
    var d = giftData(); var boxes = $$('[data-nk-gift]');
    if (!d || !boxes.length || !c) return;
    if (!c.item_count) { boxes.forEach(function (b) { b.hidden = true; b.innerHTML = ''; }); return; }
    var s = giftCalc(c), ok = s.base >= d.threshold, html, amt = money(d.threshold);
    if (s.gl && !ok) {
      html = '<p class="nk-gift__title">無料プレゼント</p><p class="nk-gift__txt">商品合計が' + amt + '未満になったため、プレゼントをカートから外しました。</p>';
      if (!giftBusy) { giftBusy = true; post('/cart/change.js', { id: s.gl.key, quantity: 0 }).then(after).catch(fail).then(function () { giftBusy = false; }); }
    } else if (s.gl) {
      html = '<p class="nk-gift__title">無料プレゼントを追加しました</p>' +
        '<p class="nk-gift__txt">' + esc(s.gl.product_title || '') + (s.gl.variant_title ? '（' + esc(s.gl.variant_title) + '）' : '') + 'は、お会計のときに0円になります。別の商品・色に変える場合は、下から選び直してください。</p>' +
        '<div class="nk-gift__row"><label class="visually-hidden" for="NkGiftSwap">プレゼントを変える</label><select id="NkGiftSwap" data-nk-gift-swap data-key="' + esc(s.gl.key) + '">' + giftOptions(d, s.gl.variant_id) + '</select></div>';
    } else if (ok) {
      html = '<p class="nk-gift__title">無料プレゼントの対象です</p>' + giftBar(100) +
        '<p class="nk-gift__txt">' + esc(d.name) + 'から好きなものを1点選んで、カートに追加してください（お会計のときに0円になります）。</p>' +
        '<div class="nk-gift__row"><label class="visually-hidden" for="NkGiftVar">プレゼントを選ぶ</label><select id="NkGiftVar" data-nk-gift-var>' + giftOptions(d) + '</select>' +
        '<button type="button" class="gb-btn gb-btn--accent nk-gift__add" data-nk-gift-add>カートに追加（0円）</button></div>';
    } else {
      html = '<p class="nk-gift__title">あと' + money(d.threshold - s.base) + 'で無料プレゼント</p>' + giftBar(Math.round(s.base / d.threshold * 100)) +
        '<p class="nk-gift__txt">割引後の商品合計' + amt + '以上で、' + esc(d.name) + 'から好きなものを1点プレゼント（商品と色を選べます）</p>';
    }
    boxes.forEach(function (b) { b.innerHTML = html; b.hidden = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nk-gift-add]');
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var sel = b.closest('[data-nk-gift]').querySelector('[data-nk-gift-var]');
    if (!sel || !sel.value) return;
    b.setAttribute('aria-busy', 'true');
    post('/cart/add.js', { items: [{ id: parseInt(sel.value, 10), quantity: 1, properties: GIFT_PROPS }] }).then(after).catch(fail).then(function () { b.removeAttribute('aria-busy'); });
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-nk-gift-swap]');
    if (!s) return;
    s.disabled = true;
    post('/cart/change.js', { id: s.getAttribute('data-key'), quantity: 0 })
      .then(function () { return post('/cart/add.js', { items: [{ id: parseInt(s.value, 10), quantity: 1, properties: GIFT_PROPS }] }); })
      .then(after).catch(fail).then(function () { s.disabled = false; });
  });

  function onRender(c) {
    try { lockLines(c); } catch (e) {}
    var changing = false;
    try { changing = syncBundle(c); } catch (e) {}
    if (!changing) { try { renderGift(c); } catch (e) {} }
  }
  function patchCart() {
    var C = window.GB && window.GB.cart;
    if (!C || C.__nkGift || typeof C.render !== 'function') return;
    C.__nkGift = true;
    var orig = C.render;
    C.render = function (c) { orig.call(this, c); onRender(c); };
    if (C.state) onRender(C.state);
  }

  /* ---------- 購入通知 ---------- */
  function initNotify() {
    var el = document.querySelector('[data-nk-notify]'), d = readJSON('[data-nk-notify-json]');
    if (!el || !d || el.__nk) return;
    el.__nk = true;
    try { if (sessionStorage.getItem('nkNotifyOff') === '1') return; } catch (e) {}
    var now = Date.now(), maxMin = (d.maxAge || 7) * 1440;
    var items = (d.items || []).map(function (it) {
      var m = it.at ? Math.floor((now - Date.parse(it.at)) / 60000) : (it.ago || 0);
      return { t: it.title, u: it.url, i: it.img, a: it.area, m: m };
    }).filter(function (it) { return it.t && !isNaN(it.m) && it.m >= 0 && it.m <= maxMin; });
    if (!items.length) return;
    var ago = function (m) { if (m < 1) return 'たった今'; if (m < 60) return m + '分前'; var h = Math.floor(m / 60); if (h < 24) return h + '時間前'; return Math.floor(h / 24) + '日前'; };
    var i = 0, max = d.sample ? 1000 : items.length, timer, hideTimer;
    var schedule = function (sec) { clearTimeout(timer); timer = setTimeout(show, sec * 1000); };
    var hide = function () { el.classList.remove('is-on'); setTimeout(function () { el.hidden = true; }, 300); if (i < max) schedule(d.interval || 25); };
    function show() {
      if (document.documentElement.classList.contains('gb-drawer-open')) { schedule(5); return; }
      var it = items[i % items.length]; i++;
      el.innerHTML = (it.i ? '<img src="' + esc(it.i) + '" alt="" width="48" height="48" loading="lazy">' : '<span></span>') +
        '<p class="nk-notify__txt"><span>' + esc(it.a ? it.a + 'のお客様が購入しました' : 'ご購入がありました') + '</span>' +
        (it.u ? '<a href="' + esc(it.u) + '"><b>' + esc(it.t) + '</b></a>' : '<b>' + esc(it.t) + '</b>') +
        '<small>' + ago(it.m) + (d.sample ? '・サンプル表示（編集画面のみ）' : '') + '</small></p>' +
        '<button type="button" class="nk-notify__close" data-nk-notify-close aria-label="購入通知を閉じる">×</button>';
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-on'); });
      clearTimeout(hideTimer); hideTimer = setTimeout(hide, 6000);
    }
    el.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nk-notify-close]')) return;
      clearTimeout(timer); clearTimeout(hideTimer);
      el.classList.remove('is-on'); el.hidden = true;
      try { sessionStorage.setItem('nkNotifyOff', '1'); } catch (er) {}
    });
    schedule(d.sample ? 3 : 8);
  }

  /* ---------- レビュー：すべて見る／クーポンのコピー ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nk-rv-more]');
    if (b) { var sec = b.closest('[data-nk-rv]'); $$('[data-nk-rv-extra]', sec).forEach(function (li) { li.hidden = false; }); b.parentNode.hidden = true; return; }
    var cp = e.target.closest && e.target.closest('[data-nk-copy]');
    if (cp) {
      var code = cp.getAttribute('data-nk-copy');
      var done = function () { cp.textContent = 'コピーしました'; setTimeout(function () { cp.textContent = 'コピー'; }, 2000); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, function () {});
    }
  });

  function start() { patchCart(); initNotify(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();